import type { QueryClient } from "@tanstack/react-query";
import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";
import { queryInvalidationHelpers } from "@/lib/queryInvalidationHelpers";

export type MembershipVisitSource =
  | "join"
  | "accept_invitation"
  | "force_join"
  | "auto_join_free"
  | "auto_join_invited";

interface FinalizeMembershipJoinParams {
  queryClient: QueryClient;
  studyGroupId: string | number;
  source: MembershipVisitSource;
}

export interface FinalizeMembershipJoinResult {
  lastVisitUpdated: boolean;
}

const visitFailureLogPrefix: Record<MembershipVisitSource, string> = {
  join: "Failed to record study group visit after join:",
  accept_invitation:
    "Failed to record study group visit after accepting invitation:",
  force_join: "Failed to record study group visit after force join:",
  auto_join_free:
    "Failed to record study group visit after auto joining study group:",
  auto_join_invited:
    "Failed to record study group visit after force joining from invitation:",
};

export const finalizeMembershipJoin = async ({
  queryClient,
  studyGroupId,
  source,
}: FinalizeMembershipJoinParams): Promise<FinalizeMembershipJoinResult> => {
  let lastVisitUpdated = false;
  try {
    await studyGroupsApi.updateLastVisit(studyGroupId);
    lastVisitUpdated = true;
  } catch (error) {
    console.error(visitFailureLogPrefix[source], { studyGroupId, error });
  }

  queryInvalidationHelpers.invalidateOnMembershipChange(
    queryClient,
    studyGroupId,
  );

  return { lastVisitUpdated };
};
